export default __webpack_public_path__ + "static/media/coin_eusdt.53a2c451.svg";